import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { FormControlLabel, Checkbox } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  checkboxLabel: {
    margin: 0,
    '& .MuiFormControlLabel-label': {
      fontSize: 'var(--font-size-sm)'
    }
  }
}))

const CheckboxList = forwardRef(({ options = [], value = [], onChange, onBlur, disabled }, ref) => {
  const classes = useStyles()

  const handleToggle = (optionValue) => {
    const currentIndex = value.indexOf(optionValue)
    const newValue = [...value]

    if (currentIndex === -1) {
      newValue.push(optionValue)
    } else {
      newValue.splice(currentIndex, 1)
    }

    onChange(newValue)
  }

  return (
    <div className={classes.container} ref={ref}>
      {options.map((option) => (
        <FormControlLabel
          key={option.value}
          className={classes.checkboxLabel}
          control={
            <Checkbox
              checked={value.includes(option.value)}
              onChange={() => handleToggle(option.value)}
              onBlur={onBlur}
              disabled={disabled}
              color='primary'
            />
          }
          label={option.label}
        />
      ))}
    </div>
  )
})

CheckboxList.displayName = 'CheckboxList'

CheckboxList.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    data: PropTypes.any
  })).isRequired,
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool
}

export default CheckboxList
